document.addEventListener('DOMContentLoaded', function() {
    let gallery_slider_blocks = document.querySelectorAll(".block.gallery-slider");
    if (gallery_slider_blocks) {
        gallery_slider_blocks.forEach((gallery) => {

            let left_arrow =
                '<svg width="13" height="21" viewBox="0 0 13 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.10913 10.8125L10.3835 20.1045L11.697 18.7871L4.09155 11.166L3.73999 10.8125L4.09155 10.459L11.697 2.83691L10.3835 1.51953L1.10913 10.8125Z"/></svg>';
            let right_arrow =
                '<svg width="13" height="21" viewBox="0 0 13 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.8828 10.8125L2.6084 20.1045L1.29492 18.7871L8.90039 11.166L9.25195 10.8125L8.90039 10.459L1.29492 2.83691L2.6084 1.51953L11.8828 10.8125Z" /></svg>';

            let slider = gallery.querySelector(".gallery-slider--gallery");

            var gallery_slider = tns({
                container: slider,
                items: 2,
                slideBy: 1,
                autoplay: false,
                nav: false,
                controls: true,
                controlsText: [left_arrow, right_arrow],
                controlsPosition: "bottom",
                loop: true,
                gutter: 3,
                touch: true,
                responsive: {
                    768: {
                        items: 3,
                    },
                    1024: {
                        items: 5,
                    },
                },
            });
        });
    }
});